import { defineStorefront } from "@kss/storefront-config"

export const bwatcher = defineStorefront({
  id: "bwatcher",
  origin: "https://bwatcher.cl",
  locale: "es-CL",
  currencyCode: "clp",
  brand: { name: "BURG-WÄCHTER Chile", shortName: "BURG-WÄCHTER", logoPath: "/bwatcher/logo-white.png" },
  header: { logoDisplay: "image", showAccount: false, showSearch: true, sticky: true, desktopCategoryLimit: 4 },
  commerce: {
    mode: "catalog",
    defaultCountryCode: "cl",
    backendUrlEnv: "NEXT_PUBLIC_MEDUSA_BACKEND_URL",
    publishableKeyEnv: "MEDUSA_CATALOG_PUBLISHABLE_KEY",
    salesChannelIdEnv: "NEXT_PUBLIC_MEDUSA_SALES_CHANNEL_ID",
    taxPresentation: "gross",
  },
  search: { tenant: "bwatcher", gatewayUrlEnv: "NEXT_PUBLIC_SEARCH_GATEWAY_URL" },
  cache: { namespace: "bwatcher" },
  theme: {
    colorBrand: "#ffcc00", colorBrandHover: "#e6b800", colorOnBrand: "#000000",
    colorAccent: "#e30613", colorBackground: "#f5f5f5", colorSurface: "#ffffff",
    colorForeground: "#27292b", colorMuted: "#62696d", colorBorder: "#d6d8d9", colorFocus: "#866a00",
    colorHeaderBackground: "#27292b", colorHeaderForeground: "#ffffff", colorHeaderBorder: "#47494b",
    colorHeaderInteractive: "#ffcc00", colorHeaderBadgeBackground: "#ffffff", colorHeaderBadgeForeground: "#27292b",
    // The published theme declares custom font files, but its active font variables use Helvetica.
    fontSans: "Helvetica, Arial, sans-serif", fontHeading: "Helvetica, Arial, sans-serif",
    headerHeight: "81px", headerLogoMaxWidth: "140px", radiusControl: "6px", radiusCard: "0px",
    shadowCard: "none",
  },
  features: { blog: false, renting: false, quotes: false, reviews: false, wishlist: false, receptionist: false },
})

export { catalogContent } from "./burg-content"
